'use client'

import { Button, Container, Dialog, Spacer, Text } from '@vinted/web-ui'

import {
  businessAccountFromUserDto,
  deleteBusinessRegistration,
} from '@marketplace-web/business-accounts/business-accounts-data'
import { useSession } from '@marketplace-web/shared/session-data'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

import { reloadPage } from '@marketplace-web/shared/browser-util'

type Props = {
  isOpen: boolean
  onClose: () => void
}

const CancelRegistrationModal = ({ isOpen, onClose }: Props) => {
  const translate = useTranslate('business.account.cancel_registration_modal')
  const { user } = useSession()
  const businessAccountId = businessAccountFromUserDto(user)?.id

  async function handleCancelRegistrationClick() {
    if (!businessAccountId) return

    await deleteBusinessRegistration(businessAccountId)

    reloadPage()
  }

  return (
    <Dialog show={isOpen}>
      <Container>
        <Text
          as="h1"
          text={translate('title')}
          type={Text.Type.Heading}
          alignment={Text.Alignment.Center}
          width={Text.Width.Parent}
        />
        <Spacer />
        <Text as="span" text={translate('body')} />
        <Spacer size={Spacer.Size.XLarge} />
        <Button
          text={translate('actions.cancel')}
          onClick={handleCancelRegistrationClick}
          styling={Button.Styling.Filled}
        />
        <Spacer size={Spacer.Size.Large} />
        <Button text={translate('actions.close')} onClick={onClose} styling={Button.Styling.Flat} />
      </Container>
    </Dialog>
  )
}

export default CancelRegistrationModal
